/* import __COLOCATED_TEMPLATE__ from './screen-config-editor-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class ScreenConfigEditorCardComponent extends Component
{
	@action updateField(field, event)
	{
		let value = event.target.value;
		// Convert to number for numeric fields
		if (field === 'precision' || field === 'offset' || field === 'limit') {
			value = parseInt(value) || 0;
		}
		this.args.onUpdate({ ...this.args.card, [field]: value });
	}

	@action updateCheckbox(field, event)
	{
		this.args.onUpdate({ ...this.args.card, [field]: event.target.checked });
	}

	// Column config management
	@action addColumn()
	{
		const newColumns = [...(this.args.card.columns || []), { name: '', width: '' }];
		this.args.onUpdate({ ...this.args.card, columns: newColumns });
	}

	@action removeColumn(columnIndex)
	{
		const newColumns = (this.args.card.columns || []).filter((_, i) => i !== columnIndex);
		this.args.onUpdate({ ...this.args.card, columns: newColumns });
	}

	@action updateColumn(columnIndex, updatedColumn)
	{
		const newColumns = [...(this.args.card.columns || [])];
		newColumns[columnIndex] = updatedColumn;
		this.args.onUpdate({ ...this.args.card, columns: newColumns });
	}
}
